/* eslint-disable react-hooks/exhaustive-deps */
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useState, useEffect, useCallback } from 'react';
import { programId, tokenId, ownerAddress, getProvider, getConnection } from '../config/web3';
import { Program } from '@project-serum/anchor';
import idl from '../idl.json';
import { Link } from 'react-router-dom';

require('@solana/wallet-adapter-react-ui/styles.css');

function Home() {
  const [pollKey, setPollKey] = useState('');
  const wallet = useWallet();

  const [voteData, setVoteDatas] = useState([])
  const [currentTransactionPage, setCurrentTransactionPage] = useState(1)
  const [transactionTotalPages, setTransactionTotalPages] = useState(0)
  const transactionItemsPerPage = 5
  const [transactionPageNumbers, setTransactionPageNumbers] = useState([])

  const calculateTransactionPageNumbers = (totalPages, currentPage) => {
    let pages = []

    if (totalPages <= 4) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1)
    } else {
      if (currentPage === 1) {
        pages = [1, 2, '...', totalPages - 1, totalPages]
      } else if (currentPage === totalPages) {
        pages = [1, 2, '...', totalPages - 1, totalPages]
      } else {
        if (currentPage + 1 < totalPages) {
          if (currentPage + 1 === totalPages - 1) {
            pages = [currentPage - 1, currentPage, currentPage + 1, totalPages]
          } else {
            pages = [
              currentPage - 1,
              currentPage,
              currentPage + 1,
              '...',
              totalPages
            ]
          }
        } else if (currentPage < totalPages) {
          pages = [currentPage - 1, currentPage, currentPage + 1]
        } else {
          pages = [1, 2, '...', totalPages - 1, totalPages]
        }
      }
    }

    return pages
  }

  const handleTransactionPageChange = newPageNumber => {
    setCurrentTransactionPage(newPageNumber)
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(transactionTotalPages, newPageNumber)
    )
  }

  useEffect(() => {
    const totalPages = Math.ceil(
      voteData.length / transactionItemsPerPage
    )
    setTransactionTotalPages(totalPages)
    setTransactionPageNumbers(
      calculateTransactionPageNumbers(totalPages, currentTransactionPage)
    )
  }, [voteData])

  // const [tokenBalance, setTokenBalance] = useState(0);
  // useEffect(() => {
  //   const fetchTokenBalance = async () => {
  //     if (!wallet.publicKey) {
  //       console.log('Wallet not connected');
  //       return;
  //     }
  //     try {
  //       const connection = await getConnection()
  //       const tokenAccounts = await connection.getParsedTokenAccountsByOwner(
  //         wallet.publicKey,
  //         { mint: tokenId }
  //       );

  //       let balance = 0;
  //       tokenAccounts.value.forEach(accountInfo => {
  //         balance += accountInfo.account.data.parsed.info.tokenAmount.uiAmount;
  //       });
  //       setTokenBalance(balance);
  //     } catch (error) {
  //       console.error('Error fetching token balance:', error);
  //     }
  //   };

  //   fetchTokenBalance();
  // }, [wallet.publicKey]);

  //pool list check
  const subscribe = useCallback(async () => {
    const provider = await getProvider(wallet)
    const program = new Program(idl, programId, provider);
    const allData = await program.account.poll.all();
    let voteData;
    let voteDatas = []
    for (let i = 0; i < allData?.length; i++) {
      let voteId = allData[i].publicKey.toString()
      let title = allData[i].account.title.toString()
      let voters = allData[i].account.voters.length
      let optionsLength = allData[i].account.options.length
      let createdTime = allData[i].account.createdTime.toString()
      voteData = {
        VoteId: voteId,
        Title: title,
        Voters: voters,
        Options: optionsLength,
        CreatedTime: Number(createdTime)
      }
      voteDatas.push(voteData)
    }
    var byDate = voteDatas.slice(0);
    byDate.sort(function (a, b) {
      return a.CreatedTime - b.CreatedTime;
    });
    setVoteDatas(byDate.reverse())
  }, [wallet]);

  useEffect(() => {
    if (wallet.connected) {
      subscribe();
    }
  }, [subscribe, wallet]);

  if (!wallet.connected && !wallet.connecting) {
    return (
      <div className="flex flex-col items-center gap-20 justify-center w-full mt-20 relative">
        <h1 className="text-2xl md:text-4xl text-white font-bold">
          Connect your wallet to vote!
        </h1>
        <WalletMultiButton />
      </div>
    )
  }

  // if (Number(tokenBalance) === 0) {
  //   return (
  //     <div className="flex flex-col items-center gap-20 justify-center w-full mt-20 relative">
  //       <h1 className="text-2xl md:text-4xl text-white font-bold">
  //         You need some tokens in your wallet
  //       </h1>
  //     </div>
  //   )
  // }

  return (
    <div className="flex flex-col items-center justify-center lg:gap-2 mt-10 w-full sm:display-column sm:pt-150px lg:flex-row relative">
      <div className="w-[100%] rounded-xl p-0 lg:mt-5 sm:mt-[10%] w-[90%] sm:p-2 lg:w-[50%] border border-[var(--token-d559605d-d2a3-4776-a2c1-0436ceda3b18, rgba(255, 255, 255, 0.15))] ">
        <h1 className="text-4xl text-white font-bold text-center mt-10 font-frescito">
          Latest Community Buy Proposal
        </h1>
        <div className="w-full rounded-xl p-0 sm:p-2 text-center text-2xl">
          <div className="tradeBox py-2 mt-[30px]">
            <p className='w-[70%]'>Title</p>
            {/* <p className='w-[30%]'>Vote Id</p> */}
            <p className='w-[35%]'>Voters</p>
            {/* <p className='w-[15%]'>Options</p> */}
          </div>
          <div className='flex flex-col gap-2 mb-[50px]'>
            {voteData.length === 0 && (
              <div className='flex backdrop-brightness-75 py-3 rounded-full justify-center text-white text-sm px-2'>No Data</div>
            )}
            {voteData.length > 0 && voteData
              .slice(
                (currentTransactionPage - 1) *
                transactionItemsPerPage,
                currentTransactionPage * transactionItemsPerPage
              )
              .map(
                ({ VoteId, Title, Voters, Options }) => (
                  <>
                    <div className="flex backdrop-brightness-75 py-3 rounded justify-between px-2 sm:px-4 items-center">
                      <div className='w-[70%]'>
                        <Link to={`/soll/${VoteId}`} className='flex items-center justify-center hover:text-red-500'>
                          <p className="tokenLists text-white hover:text-blue-500">Community Token Buy - 5th February 2025</p>
                          {/* &nbsp; &nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#ffffff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide-icon lucide lucide-external-link h-4 w-4"
                          >
                            <path d="M15 3h6v6"></path>
                            <path d="M10 14 21 3"></path>
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                          </svg>
                          &nbsp; */}
                        </Link>
                      </div>
                      {/* <div className='w-[30%] flex justify-center'>
                        <Link to={`/soll/${VoteId}`} className='flex items-center'>
                          <p className="tokenLists text-[#4fa9ff]">
                            {VoteId.slice(0, 5) +
                              '...' +
                              VoteId.slice(-3)}
                          </p>
                          &nbsp; &nbsp;
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#4fa9ff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide-icon lucide lucide-external-link h-4 w-4"
                          >
                            <path d="M15 3h6v6"></path>
                            <path d="M10 14 21 3"></path>
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                          </svg>
                          &nbsp;
                        </Link>
                      </div> */}
                      <div className='w-[30%]'>
                        <p className="tokenLists text-white">{Voters}</p>
                      </div>
                      {/* <div className='w-[15%]'>
                        <p className="tokenLists text-white">{Options}</p>
                      </div> */}
                    </div>
                  </>
                )
              )}
            {/* <div
              className="flex justify-end my-4"
              style={{ textAlign: 'right' }}
            >
              <button
                className="px-2 py-1 mx-1 bg-primary text-white rounded-lg border border-[#4fa9ff]"
                onClick={() => handleTransactionPageChange(1)}
              >
                &lt;&lt;
              </button>
              <button
                className="px-2 py-1 mx-1 bg-primary text-white rounded-lg border border-[#4fa9ff]"
                onClick={() =>
                  handleTransactionPageChange(
                    Math.max(currentTransactionPage - 1, 1)
                  )
                }
              >
                &lt;
              </button>
              {transactionPageNumbers.map((pageNumber, index) => {
                if (typeof pageNumber === 'number') {
                  return (
                    <button
                      key={pageNumber}
                      className={`px-2 py-1 mx-1 ${currentTransactionPage === pageNumber
                        ? 'text-white'
                        : 'backdrop-brightness-90 text-[#aaa]'
                        } rounded-lg border border-[#4fa9ff]`}
                      onClick={() =>
                        handleTransactionPageChange(pageNumber)
                      }
                    >
                      {pageNumber}
                    </button>
                  )
                } else {
                  return (
                    <span
                      key={pageNumber}
                      className="px-2 py-1 mx-1 bg-transparent text-white rounded-lg border border-primary"
                    >
                      ...
                    </span>
                  )
                }
              })}
              <button
                className="px-2 py-1 mx-1 bg-primary text-white rounded-lg border border-[#4fa9ff]"
                onClick={() =>
                  handleTransactionPageChange(
                    Math.min(
                      currentTransactionPage + 1,
                      transactionTotalPages
                    )
                  )
                }
              >
                &gt;
              </button>
              <button
                className="px-2 py-1 mx-1 bg-primary text-white rounded-lg border border-[#4fa9ff]"
                onClick={() =>
                  handleTransactionPageChange(transactionTotalPages)
                }
              >
                &gt;&gt;
              </button>
            </div> */}
          </div>
        </div>
      </div>
      <div className="w-[5px] h-[40%] bg-[white]]" />
      <div className="flex:column mt-10">
        {/* <div className="flex flex-col gap-4 w-[400px] mb-20">
          <input type="text" className="backdrop-brightness-80 bg-[transparent] text-[white] text-lg p-4 rounded-xl outline-none border-[white] border"
            placeholder='Poll Code'
            value={pollKey}
            onChange={e => setPollKey(e.target.value.replace(/ /g, ''))}
          />
          <Link to={`/soll/${pollKey}`}>
            <button disabled={!pollKey} className="bg-[#cc17f2] disabled:backdrop-brightness-75 disabled:bg-[transparent] disabled:cursor-not-allowed text-white rounded-xl p-4 w-full font-semibold text-xl">
              Join Poll
            </button>
          </Link>
        </div> */}
        {
          wallet && ownerAddress === wallet.publicKey?.toString() ?
            <Link to="/create">
              <button className="bg-[#cc17f2] text-white rounded-xl p-4 w-[400px] font-semibold text-xl">
                Create Poll
              </button>
            </Link>
            :
            <></>
        }

      </div>
    </div>
  );
}

export default Home;
